import type {CommonProps} from './types';

const NoAudioFile = ({
  color = 'currentColor',
  size = 48,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    {...rest}
  >
    <g
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path
        d="M22.5 34.5a12 12 0 1024 0 12 12 0 10-24 0zM26.02 42.98l16.96-16.96"
        strokeWidth="3"
      />
      <path
        d="M16.5 40.5h-12a3 3 0 01-3-3v-33a3 3 0 013-3h21.26a3 3 0 012.12.88l5.74 5.74a3 3 0 01.88 2.12v6.26"
        strokeWidth="3"
      />
      <path d="M7.5 25.5a4.5 3 0 109 0 4.5 3 0 10-9 0z" strokeWidth="3" />
      <path
        d="M16.5 25.5l-.59-11.86 2.12-.22a5.37 5.37 0 015.17 2.56"
        strokeWidth="3"
      />
    </g>
  </svg>
);

export default NoAudioFile;
